<template>
  <v-container>
  <v-card v-for="(date, index) in gamesPerDate" :key="`date-${index}`" elevation="12" style="margin-top:10px;padding:1px">
    <v-row dense>
      <v-card-title class="text-center justify-center py-6">
        <h2 class="font-weight-bold text-capitalize">{{date[0] | moment("dddd D MMMM")}}</h2>
      </v-card-title>
    </v-row>
    <v-row dense>
      <v-col
        v-for="game in date[1]"
        :key="`game-${game.start_time}-${game.code}`"
        cols="6"
        sm="4"
        md="3"
        lg="2"
      >
        <v-card
          width="230px"
          hover
          shaped
        >
          <v-img
            :src="getImgUrl(game.code + '.png')"
            class="white--text align-end"
            style="background-color: rgb(89,89,83)"
            gradient="to bottom, rgba(0,0,0,.1) 50%, rgba(0,0,0,.7)"
            height="100px"
            width="230px"
          >
          </v-img>

          <v-card-text>
            <p class="text--primary">
              {{game.code}} {{game.track.track_name}}
            </p>
            <p>
              {{game.start_time | moment("HH:mm")}}
               ({{game.start_time | fromNow}})
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" outlined @click="createSystem(game)">
              <v-icon>mdi-plus</v-icon>
              Spela
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>
      </v-card>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
    }
  },

  mounted () {
    this.fetchGamesAction()
  },

  methods: {
    ...mapActions(['fetchGamesAction', 'createSystemAction']),

    createSystem (game) {
      const systemDetails = { track_id: game.track.track_id, date: game.track.date, code: game.code }
      this.createSystemAction(systemDetails)
        .then(response => {
          this.$router.push({ path: `/systems/${response.system.SystemGUID}` })
        })
    },

    groupBy (list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },

    getImgUrl (pic) {
      return require('@/assets/' + pic)
    }
  },

  computed: {
    gamesList () {
      return this.$store.state.games.games
    },
    gamesPerDate () {
      var dates = this.groupBy(this.gamesList, function (game) {
        return moment(game.start_time).startOf('day').format()
      })

      return Array.from(dates)
    }
  }
}
</script>
